import { contract } from "@conciliacion/api";
import { initQueryClient } from "@ts-rest/react-query";

/**
 * El cliente tipado de la API. Sale del mismo contrato que implementa el
 * servidor, así que cambiar una respuesta allá rompe la compilación acá.
 *
 * `credentials: "include"` no es opcional: sin eso el navegador no adjunta la
 * cookie de sesión y todo responde 401 con el usuario perfectamente logueado.
 */
export const api = initQueryClient(contract, {
  baseUrl: "",
  baseHeaders: {},
  api: async ({ path, method, headers, body }) => {
    const res = await fetch(`/rest${path}`, {
      method,
      headers,
      body,
      credentials: "include",
    });

    const texto = await res.text();
    let datos: unknown = texto;
    try {
      datos = texto ? JSON.parse(texto) : null;
    } catch {
      // Si la respuesta no es JSON (un 502 del túnel devuelve HTML, por
      // ejemplo), se deja el texto crudo: es lo que hace falta para entender
      // qué pasó, y parsearlo a la fuerza escondería el problema real.
    }

    return {
      status: res.status,
      body: datos,
      headers: res.headers,
    };
  },
});
